import Vue from "vue";
import App from "./app/App.vue";
import router from "./app/plugins/router";
import store from "./app/plugins/store";
import vuetify from "./app/plugins/vuetify";

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
